<div class="container locker-checkout">
  <div class="row checkout-grid">
    <div class="col-sm-12 col-md-5 form-reserve">
      <div class="checkout-heading">
        <span class="checkout-step" aria-hidden="true">1</span>
        <div>
          <h1>{{'checkout.yourDetails'|traduccion}}</h1>
          <p>{{'label.info.raison.phone'|traduccion}}</p>
        </div>
      </div>

      @if (type==0) {
        <div class="mb-3">
          <!--
          <div *ngIf="!appService.autenticado()">
            <p>{{'checkout.doYouCustomPassword'|traduccion}}
              <a class="nav-link p-0 d-inline-block text-muted" rel="tooltip" title="Login" data-placement="bottom" (click)="login()" target="_self">{{'checkout.signinOrSignup'|traduccion}}</a>
            </p>
          </div>
          -->
          @if (appService.autenticado()) {
            <div>
              <p>{{'checkout.loginAs'|traduccion}} {{appService.usuario.username}},
                <a class="nav-link p-0 d-inline-block text-muted" rel="tooltip" title="Logout" data-placement="bottom" (click)="logout()" target="_self">{{'checkout.logout'|traduccion}}</a>
              </p>
            </div>
          }
        </div>
      }

      <form id="form-checkout" [formGroup]="heroForm">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <i class="nc-icon nc-single-02 checkout-field-icon" aria-hidden="true"></i>
                <input formControlName="name" type="text" class="form-control" id="name" placeholder="Nombre" autocomplete="name" aria-label="Nombre" [readonly]="appService.autenticado()"/>
                @if (name.invalid && (name.dirty || name.touched)) {
                  <div class="alert alert-danger">
                    @if (name.errors.required) {
                      <div>
                        {{'name.errors.required'|traduccion}}
                      </div>
                    }
                    @if (name.errors.minlength) {
                      <div>
                        {{'name.errors.minlength'|traduccion}}
                      </div>
                    }
                    @if (name.errors.forbiddenName) {
                      <div>
                        {{'name.errors.forbiddenName'|traduccion}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <i class="nc-icon nc-email-85 checkout-field-icon" aria-hidden="true"></i>
                <input formControlName="email" type="email" class="form-control" id="email" placeholder="Email" autocomplete="email" aria-label="Email" [readonly]="appService.autenticado()" />
                @if (email.invalid && (email.dirty || email.touched)) {
                  <div class="alert alert-danger">
                    @if (email.errors.required) {
                      <div>
                        {{'email.errors.required'|traduccion}}
                      </div>
                    }
                    @if (email.errors.minlength) {
                      <div>
                        {{'email.errors.minlength'|traduccion}}
                      </div>
                    }
                    @if (email.errors.email) {
                      <div>
                        {{'email.errors.forbiddenName'|traduccion}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="mb-3">
                <!--
                <select formControlName="extension" class="form-control" id="extension" placeholder="Extension">
                  <option selected>{{'reserve.select'|traduccion}}</option>
                  <option *ngFor="let phone of appService.phone" value="{{phone.dial_code}}">{{phone.name}}</option>
                </select>
                -->
                <i class="nc-icon nc-mobile checkout-field-icon" aria-hidden="true"></i>
                <input formControlName="extension" type="text" class="form-control" id="extension" [placeholder]="'checkout.extension'|traduccion" [attr.aria-label]="'checkout.extension'|traduccion" autocomplete="tel-country-code" (blur)="transformExtension()"/>
                @if (extension.invalid && (extension.dirty || extension.touched)) {
                  <div class="alert alert-danger">
                    @if (extension.errors.required) {
                      <div>
                        {{'extension.errors.required'|traduccion}}
                      </div>
                    }
                    @if (extension.errors.minlength) {
                      <div>
                        {{'extension.errors.minlength'|traduccion}}
                      </div>
                    }
                    @if (extension.errors.pattern) {
                      <div>
                        {{'extension.errors.pattern'|traduccion}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col">
              <div class="mb-3">
                <i class="nc-icon nc-mobile checkout-field-icon" aria-hidden="true"></i>
                <input formControlName="telephoneNumber" type="tel" class="form-control" id="telephone_number" maxlength="20" autocomplete="tel-national" [attr.aria-label]="'checkout.telephoneNumber'|traduccion"
                  placeholder="{{'checkout.telephoneNumber'|traduccion}}" />
                  @if (telephoneNumber.invalid && (telephoneNumber.dirty || telephoneNumber.touched)) {
                    <div class="alert alert-danger">
                      @if (telephoneNumber.errors.required) {
                        <div>
                          {{'telephoneNumber.errors.required'|traduccion}}
                        </div>
                      }
                      @if (telephoneNumber.errors.minlength) {
                        <div>
                          {{'telephoneNumber.errors.minlength'|traduccion}}
                        </div>
                      }
                      @if (telephoneNumber.errors.pattern) {
                        <div>
                          {{'telephoneNumber.errors.pattern'|traduccion}}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="row checkout-email-note">
              <div class="col">
                <div class="mb-3">
                  <label class="form-label">{{'label.info.raison.phone'|traduccion}}</label>
                </div>
              </div>
            </div>

            @if (appService.autenticado() && isModeKey && !isRenovation()) {
              <div class="row">
                <div class="col">
                  <p>{{'checkout.customPassword'|traduccion}}</p>
                </div>
              </div>
            }

            @if (appService.autenticado() && isModeKey && !isRenovation()) {
              <div class="row">
                <div class="col">
                  <div class="mb-3">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">0{{appService.usuario.id}}+</span>
                      </div>
                      <input formControlName="provisionalPasswordLocker" type="number" class="form-control pass"
                        id="provisional_locker_password" placeholder="{{'checkout.deliver'|traduccion}}" minlength="4" maxlength="4" />
                        <small id="provisional_locker_password" class="form-text text-muted">{{'checkout.passwordToDeliver'|traduccion}} {{formatPin(provisionalPasswordLocker.value)}}</small>
                        @if (provisionalPasswordLocker.invalid && (provisionalPasswordLocker.dirty || provisionalPasswordLocker.touched)) {
                          <div
                            class="alert alert-danger">
                            @if (provisionalPasswordLocker.errors.required) {
                              <div>
                                {{'passwordLocker.errors.required'|traduccion}}
                              </div>
                            }
                            @if (provisionalPasswordLocker.errors.minlength || provisionalPasswordLocker.errors.maxlength) {
                              <div>
                                {{'passwordLocker.errors.minlength'|traduccion}}
                              </div>
                            }
                            @if (provisionalPasswordLocker.errors.pattern) {
                              <div>
                                {{'passwordLocker.errors.pattern'|traduccion}}
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">0{{appService.usuario.id}}+</span>
                        </div>
                        <input formControlName="checkoutPasswordLocker" type="number" class="form-control pass" id="locker_password"
                          placeholder="{{'checkout.pickup'|traduccion}}" minlength="4" maxlength="4" />
                          <small id="provisional_locker_password" class="form-text text-muted">{{'checkout.passwordToPickup'|traduccion}} {{formatPin(checkoutPasswordLocker.value)}}</small>
                          @if (checkoutPasswordLocker.invalid && (checkoutPasswordLocker.dirty || checkoutPasswordLocker.touched)) {
                            <div
                              class="alert alert-danger">
                              @if (checkoutPasswordLocker.errors.required) {
                                <div>
                                  {{'passwordLocker.errors.required'|traduccion}}
                                </div>
                              }
                              @if (checkoutPasswordLocker.errors.minlength || checkoutPasswordLocker.errors.maxlength) {
                                <div>
                                  {{'passwordLocker.errors.minlength'|traduccion}}
                                </div>
                              }
                              @if (checkoutPasswordLocker.errors.pattern) {
                                <div>
                                  {{'passwordLocker.errors.pattern'|traduccion}}
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }


                <div class="row">
                  <div class="col">
                    <p class="discount-heading">{{'checkout.info.discountCode'|traduccion}}</p>
                    <div class="mb-3">
                      <div class="row">
                        <div class="col">
                          <i class="nc-icon nc-tag-content checkout-field-icon" aria-hidden="true"></i>
                          <input formControlName="discountCode" type="text" maxlength="8" oninput="this.value = this.value.toUpperCase()" [readonly]="discountValidated" class="form-control" id="discount_code" placeholder="{{'checkout.info.discountCode.placeholder'|traduccion}}" aria-label="{{'checkout.info.discountCode.placeholder'|traduccion}}" />
                        </div>
                        <div class="col">
                          @if (!discountValidated) {
                            <button type="button" class="btn btn-primary btn-round" [disabled]="(discountCode.value == null || discountCode.value == '') || (discountCode.invalid && (discountCode.dirty || discountCode.touched))" (click)="validateDiscount()">
                              {{'checkout.bt.validateDiscount'|traduccion}}
                            </button>
                          }
                          @if (discountValidated) {
                            <button type="button" class="btn btn-primary btn-round" (click)="deleteDiscount()">
                              {{'checkout.bt.deleteDiscount'|traduccion}}
                            </button>
                          }
                        </div>
                      </div>
                      @if (discountCode.invalid && (discountCode.dirty || discountCode.touched)) {
                        <div class="alert alert-danger">
                          @if (discountCode.errors.required) {
                            <div>
                              {{'reserve.discountRequired'|traduccion}}
                            </div>
                          }
                          @if (discountCode.errors.minlength) {
                            <div>
                              {{'discountCode.errors.minlength'|traduccion}}
                            </div>
                          }
                          @if (discountCode.errors.forbiddenName) {
                            <div>
                              {{'reserve.discountInvalid'|traduccion}}
                            </div>
                          }
                        </div>
                      }
                      @if (heroForm?.errors?.discountValidated) {
                        <div class="alert alert-danger mt-2">
                          <div>
                            {{'discountCode.errors.discountValidated'|traduccion}}
                          </div>
                        </div>
                      }

                    </div>
                  </div>
                </div>
                <!--
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label for="insurance" class="checkbox-inline">
                        <input formControlName="insurance" type="checkbox" id="insurance" />
                      {{'label.info.raison.segure'|traduccion}}</label>
                    </div>
                  </div>
                </div>
                -->
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label for="agreement" class="checkbox-inline">
                        <input formControlName="agreement" type="checkbox" id="agreement" />
                        {{'label.checkout.agreement'|traduccion}} <a class="agreement-link" target="_blank" [routerLink]="language.path('terms-conditions')">{{'checkout.agreement.open'|traduccion}}</a>
                      </label>
                      @if (agreement.invalid && (agreement.dirty || agreement.touched)) {
                        <div class="alert alert-danger">
                          @if (agreement.errors.required) {
                            <div>
                              {{'agreement.errors.required'|traduccion}}
                            </div>
                          }
                          @if (agreement.errors.minlength) {
                            <div>
                              {{'reserve.agreementTooShort'|traduccion}}
                            </div>
                          }
                          @if (agreement.errors.forbiddenName) {
                            <div>
                              {{'reserve.agreementInvalid'|traduccion}}
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div> <!-- /container -->
            </form> <!-- /form -->

          </div> <!-- /col form-reserve -->
            <div class="col-sm-12 col-md-5 offset-md-0 offset-md-2 resumen-reserve">

            <div class="col-sm">
              <div class="mb-3">
                <h4 class="text-light mt-0">{{'checkout.reserve'|traduccion}}</h4>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <div class="card-text">
                  <div>
                    <div class="resumen-location">
                      <p><i class="nc-icon nc-pin-3" aria-hidden="true"></i>{{infoCart.kioskAddress}}</p>
                    </div>
                    <div class="resumen-date">
                      <p><i class="nc-icon nc-calendar-60" aria-hidden="true"></i>{{'checkout.from'|traduccion}} {{this.infoCart.startDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</p>
                      <p><i class="nc-icon nc-calendar-60" aria-hidden="true"></i>{{'checkout.to'|traduccion}} {{this.infoCart.endDate | date: appService.FORMAT_DATETIME : appService.TIMEZONE_OFFSET() : 'es'}}</p>
                    </div>
                    <!--
                    <div class="resumen-locker">
                      <p>{{'checkout.locker'|traduccion}} {{parameters.type|traduccion}}</p>
                    </div>
                    -->
                  </div>
                </div>
              </div>
            </div>

            <div class="c-resumen">
              <div class="">
                <div class="container card">
                  @for (item of infoCart.items; track item) {
                    <div class="order mt-4">
                      <!-- {--
                      <div *ngIf="infoCart.resumen[0].priceType!=null" class="row">
                        <div class="col">
                          <div class="mb-3 bt-type-payment">
                            <button *ngIf="parameters.items[0].priceType=='RECURRENT'" (click)="onChangePrice($event)" value="UNIQUE" class="btn btn-outline-primary" [class.btTypePayment]="infoCart.resumen[0].priceType=='UNIQUE'" [disabled]="infoCart.resumen[0].priceType=='RECURRENT'">{{'checkout.UNIQUE'|traduccion}}</button>
                            <button *ngIf="parameters.items[0].priceType=='UNIQUE' || parameters.items[0].priceType==null" (click)="onChangePrice($event)" value="RECURRENT" class="btn btn-outline-primary" [class.btTypePayment]="infoCart.resumen[0].priceType=='RECURRENT'" [disabled]="infoCart.resumen[0].priceType=='UNIQUE'">{{'checkout.RECURRENT'|traduccion}}</button>
                          </div>
                        </div>
                      </div>
                      --}
                      -->
                      <!-- TODO revisar para eliminar -->
                      @if (price != null && price.items['KEYU']) {
                        <div class="row">
                          @for (p of price.items['KEYU'].alternativePrices; track p) {
                            <div class="col">
                              <div class="mb-3 bt-type-payment">
                                <button
                                  (click)="onChangePrice($event, p)"
                                  [value]="p"
                                  class="btn btn-outline-primary w-100"
                                  [class.bt-type-payment-recurrent]="infoCart.resumen[0].priceType==p.type"
                                  [disabled]="infoCart.resumen[0].id==p.id">
                                  {{p.type|traduccion}} <br> {{p.price}}{{'checkout.divisa'|traduccion}} / {{p.period}} {{p.unit|traduccion}}
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      <div class="row">
                        <p class="col font-weight-bold"><i class="nc-icon nc-box-2" aria-hidden="true"></i>{{'checkout.locker'|traduccion}} {{item.categoryCode|traduccion}}</p>
                      </div>
                      <div class="row">
                        <div class="col">
                          <p class="">{{item.unitPrice}}{{'checkout.divisa'|traduccion}} / {{item.period}} {{item.unit|traduccion}}</p>
                        </div>
                        <div class="col"></div>
                        <div class="col">
                          <p [class.overwrite-price-discount]="item.descriptionDiscount">{{item.totalPriceWithoutDiscount}}{{'checkout.divisa'|traduccion}}</p>
                        </div>
                      </div>
                      @if (item.descriptionDiscount) {
                        <div class="row discount">
                          <div class="col">
                            <p class="">{{item.descriptionDiscount}}</p>
                          </div>
                          <div class="col-4">
                            <p class="">{{item.totalPrice}} {{'checkout.divisa'|traduccion}}</p>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="mt-4"></div>
                  <hr class="hr" />
                  <div class="row">
                    <div class="col">
                      <p class="font-weight-bold">{{'checkout.total'|traduccion}}</p>
                    </div>
                    <div class="col"></div>
                    <div class="col">
                      <p class="total font-weight-bold">{{infoCart.total}}€</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div> <!-- /resumen-reserve -->
        </div>
      <section class="checkout-payment-methods" [class.free-payment]="infoCart.total == 0" aria-labelledby="payment-method-title">
        <div class="payment-method-heading">
          <h2 id="payment-method-title">{{'checkout.paymentMethod'|traduccion}}</h2>
          <p>{{'checkout.paymentMethodHint'|traduccion}}</p>
        </div>
        @if (infoCart.total != 0) {
          <div class="payment-options" role="radiogroup" [attr.aria-label]="'checkout.paymentMethod'|traduccion">
            <button type="button" class="payment-option" role="radio" [attr.aria-checked]="selectedPaymentMethod == 'card'" [class.selected]="selectedPaymentMethod == 'card'" (click)="selectPaymentMethod('card')">
              <span class="payment-radio" aria-hidden="true"></span><i class="nc-icon nc-credit-card" aria-hidden="true"></i><span>{{'checkout.card'|traduccion}}</span>
              <span class="checkout-card-logos"><span class="card-brand visa-brand" role="img" aria-label="Visa">VISA</span><span class="card-brand mastercard-brand" role="img" aria-label="Mastercard"></span><span class="card-brand amex-brand" role="img" aria-label="American Express">AMEX</span></span>
            </button>
            @if (showPaypalPayment) {
              <button type="button" class="payment-option" role="radio" [attr.aria-checked]="selectedPaymentMethod == 'paypal'" [class.selected]="selectedPaymentMethod == 'paypal'" (click)="selectPaymentMethod('paypal')">
                <span class="payment-radio" aria-hidden="true"></span><span class="paypal-brand">PayPal</span>
              </button>
            }
          </div>
        }
      </section>
      </div>
